"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputAdornmentOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, breakpoints = _a.breakpoints, palette = _a.palette;
    return ({
        root: (_b = {
                height: undefined,
                maxHeight: undefined,
                fontSize: "inherit",
                lineHeight: 1.4,
                color: palette.text.secondary,
                // Input with a label and adornments
                ".MuiInputLabel-root + .MuiInputBase-root > &": {
                    alignSelf: "flex-end",
                    paddingBottom: spacing(2),
                }
            },
            _b[breakpoints.up("xl")] = {
                lineHeight: 1.875,
            },
            _b),
        positionStart: {
            marginRight: undefined,
            paddingLeft: spacing(3),
        },
        positionEnd: {
            marginLeft: undefined,
            paddingRight: spacing(3),
            ".MuiSelect-root ~ &": {
                paddingRight: spacing(9),
            },
        },
    });
};
//# sourceMappingURL=MuiInputAdornment.js.map